const cancel = '취소'
const save = '저장'

export default {
  global: {
    generalError: '이런! 요청을 처리할 수 없습니다. 페이지를 새로 고치세요.',
    signature: '감사합니다,',
  },

  component: {
    actionBar: {
      actions: '작업',
      hideActions: '작업 숨기기',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: '추가',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: '이력서 또는 기타 요청된 첨부 파일 추가',
      placeholderWithDescription: '필요한 첨부 파일 추가',
      remove: '제거',
      allowedFileTypes: '허용된 파일 형식',
      errors: {
        size: '파일이 너무 큽니다. 파일의 크기는 5MB이하여야 합니다.',
        empty: '파일에 데이터가 없습니다',
        invalidType: fileType => `${fileType} 파일은 보안상의 이유로 허용되지 않습니다`,
        typeNotWhitelisted: '허용되지 않는 파일 형식입니다.',
      },
    },

    agreeTos: {
      privacyLinkText: '개인정보처리방침',
      termsLinkText: '이용약관',
      privacyPolicyText: '당사는 귀하의 개인정보를 소중히 여깁니다. 당사의 ',
      termsText1: '다음을 읽고 동의하세요:',
      termsText2: '(귀하의 개인 데이터를 제공하기 전)',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `당사가 귀하의 개인 데이터를 처리하기를 원하지 않으시는 경우에는 ${mail}에 메시지를 보내 삭제를 요청하시기 바랍니다.`,
      customSupportPrivacyInfo: link => `당사가 귀하의 개인 데이터를 처리하기를 원하지 않는 경우 ${link}에 연락하여 삭제를 요청하시기 바랍니다.`,
    },

    buttons: {
      close: '닫기',
    },

    competencies: {
      addCompetency: '새 역량 추가',
      edit: '역량 편집',
      done: '완료',
      defaultsDescription: '어떤 역량을 사용해야 할지 잘 모르시는 경우 도와드리기 위해 몇 가지 유용한 기본값을 정의해 두었습니다.',
      getDefaults: '기본값 가져오기',
    },

    competency: {
      warning: '역량과 모든 평가를 제거하시겠어요?',
    },

    confirmDelete: {
      delete: '삭제',
      cancel: '취소',
      confirm: '확인',
    },

    confirm: {
      cancel: '재촬영 영상 제거',
      confirm: '다시 시도하세요',
    },

    confirmButton: {
      wait: count => `${count} 대기`,
      confirm: '확인',
    },

    controlStatus: {
      text: {
        empty: '채우기',
        valid: () => '준비 완료',
      },
      textarea: {
        empty: '채우기',
        valid: (length, limit) => `${length}/${limit}자`,
      },
      select: {
        empty: '설정',
        valid: () => '준비 완료',
      },
      file: {
        empty: '선택',
        valid: () => '변경',
      },
      list: {
        empty: '추가',
        valid: (length, limit) => `${length}/${limit}자`,
      },
      search: {
        empty: '검색',
        valid: () => '준비 완료',
      },
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: '제거',
      importCsv: 'CSV 가져오기',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: '이메일이 반송되었습니다. 받는 사람이 메시지를 받았는지 확인하세요.',
      },
      Permanent: {
        General: '이메일 전송에 실패했습니다. 받는 사람이 사용하는 이메일 제공자가 메시지를 거부했습니다.',
        NoEmail: '이메일 주소가 존재하지 않습니다.',
        Suppressed: '이전에 실패한 전송 시도로 인해 이메일이 전송되지 않았습니다.',
      },
      Transient: {
        General: '이메일이 반송되었습니다. 받는 사람이 메시지를 받았는지 확인하세요.',
        MailboxFull: '받는 사람의 받은 편지함이 꽉 찼습니다.',
        MessageTooLarge: '메시지 내용의 크기가 너무 큽니다.',
        ContentRejected: '메시지 내용이 거부되었습니다.',
        AttachmentRejected: '첨부 파일이 거부되었습니다.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS 메시지가 메시지 대기열에 추가되어 전송 대기 중입니다.',
      failed: 'SMS 메시지를 보내지 못했습니다.',
      duplicate: '해당 번호는 이미 면접에서 지원자에게 부여된 번호입니다.',
    },

    error403: {
      heading: '접근 금지',
      content: '올바른 계정에 로그인했는지, Recright에서 이 직책을 검토하도록 초대받았는지 확인하세요. 또한 Recright를 하나의 브라우저 창에서 동시에 사용하고 있는지 확인하세요.',
      link: '앞면',
    },

    error404: {
      heading: '아무것도 없습니다',
      content: '열심히 찾아봤지만 요청하신 주소에 웹 페이지가 없습니다. 만료된 링크를 클릭했거나 실수로 주소를 잘못 입력하셨을 수 있습니다.',
      link: '앞면',
    },

    error410: {
      heading: '닫힘',
      content: '채용이 마감되었거나 지원 기간이 종료되어 직책을 표시할 수 없습니다.',
      link: '앞면',
    },

    calendarError: {
      heading: '캘린더를 연결하지 못했습니다',
      content: '캘린더를 연결할 수 없습니다. 나중에 다시 시도하고 문제가 계속되면 지원팀에 문의하세요.',
    },

    flash: {
      starting: '초기화 중...',
      connection_error_hint: '네트워크 연결을 설정할 수 없습니다.\n페이지를 새로 고치세요.',
      permission_hint: '이 사이트에서 웹캠과 마이크 사용을 허용해야 합니다.',
      searching_camera_hint: '웹캠 검색 중...',
      camera_reserved_hint: '다른 애플리케이션 또는 웹 페이지에서 웹캠을 사용하고 있습니다.\n해당 애플리케이션을 닫고 이 페이지를 새로 고치세요.',
      camera_reserved_hint_chrome_extra: '\n\nChrome 사용자는 주소창 아래 대화상자에서 Recright가 웹캠을 사용하도록 허용해야 합니다.',
      no_camera_hint: '웹캠을 찾을 수 없습니다.',
      no_mic_hint: '마이크를 찾을 수 없습니다.',
      uploading_text: '업로드 중 ...',
      rtmpt_in_use: '네트워크 관리자가 RTMP를 허용했다면 이 단계는\n필요하지 않습니다. 방법을 문의하세요.',
      preview_text: '웹캠이 미리보기 모드입니다',
      close_text: '카메라 닫기',
      remove_text: '재촬영 영상 제거',
      noflash_errortext_install: link => `Adobe Flash Player가 설치되지 않은 것 같습니다. 동영상을 녹화하려면 Flash 플러그인이 필요합니다. Flash 다운로드 링크는 다음과 같습니다. ${link}`,
      noflash_errortext_enable: link => `이미 Flash를 설치했지만 이 메시지가 표시되는 경우에는 다음 링크를 참조하시기 바랍니다. ${link}`,
      noflash_errortext_differentbrowser: '또는 HTML5 녹화를 지원하는 브라우저로 시도해 보셔도 됩니다. Chrome 또는 Firefox를 권장합니다.',
    },

    footer: {
      terms: '사용자 이용약관',
      license: '일반 서비스 약관',
      privacyPolicy: '개인정보처리방침',
      customSupport: link => `${link}에 문의하세요`,
      accessibilityReport: '접근성 보고서',
    },

    feedbackPulse: {
      howWouldYouRateInterview: '면접 경험을 어떻게 평가하시겠어요?',
      howWouldYouRateJobAd: '입사 지원 경험을 어떻게 평가하시겠어요?',
      yourResponseIsAnonymous: '귀하의 응답은 익명으로 유지됩니다.',
      thankYouFeedback: '의견을 남겨 주셔서 감사합니다!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    cookieConsentModal: {
      title: '당사 웹사이트에서는 쿠키를 사용합니다',
      body: '모든 쿠키를 허용하면 사이트 탐색을 개선하고 사이트 사용을 분석하며 당사의 마케팅 활동을 지원하기 위해 귀하의 기기에 쿠키를 저장하는 데 동의하는 것으로 간주됩니다.',
      learnMoreLinkText: '당사의 쿠키 사용 방식에 대해 자세히 알아보기',
      learnMoreLink: 'https://get.recright.com/cookies/',
      manageCookies: '쿠키 관리',
      acceptAll: '모든 쿠키 허용',
      manageTitle: '동의 기본 설정 관리',
      necessaryCookiesTitle: '필수 쿠키',
      necessaryCookiesBody:
        '이 쿠키는 웹사이트 작동을 위해 필요하며 당사 시스템에서 끌 수 없습니다.',
      performanceCookiesTitle: '성능 쿠키',
      performanceCookiesBody:
        '이 쿠키로 방문 및 트래픽 소스를 계산하여 사이트의 성능을 측정 및 개선할 수 있습니다.',
      marketingCookiesTitle: '마케팅 쿠키',
      marketingCookiesBody:
        '이 쿠키를 통해 당사는 광고를 개인 맞춤 설정하고 광고 실적을 측정할 수 있습니다.',
      functionalCookiesTitle: '기능 쿠키',
      functionalCookiesBody:
        '이 쿠키는 웹사이트 기능을 강화하는 데 사용됩니다. 이러한 쿠키가 없으면 특정 기능을 사용하지 못할 수 있습니다. 기능 쿠키의 예시로는 웹 채팅 서비스, 사용자 환경 설정 등이 있습니다.',
      confirmChoices: '내 선택 확인',
    },

    formErrors: {
      typeNotWhitelisted: '허용되지 않는 파일 형식입니다.',
      isRequired: '이 입력란은 필수입니다.',
      isEmail: value => `${value}은(는) 유효한 이메일이 아닙니다.`,
      isDate: value => `${value}은(는) 유효한 날짜가 아닙니다.`,
      invalidUrl: '유효하지 않은 URL입니다.',
      singleHireEndError: '1회성 채용은 60일 이상 사용할 수 없습니다.',
      isNotTooOldForLive: '과거 날짜입니다.',
      isNotAfterEndDate: '채용 공고 마감일 이후 날짜는 선택할 수 없습니다.',
      isValidMobilePhone: value => `${value ? `${value}은(는)` : '은(는)'} 올바른 휴대폰 번호가 아닙니다.`,
      isInternationalPhoneNumber: '전화번호는 국제 형식이어야 합니다.',
      duplicateNumber: '전화번호가 이미 추가되었습니다.',
      duplicateCompetency: '해당 이름의 역량이 이미 존재합니다',
      isNotDuplicateTemplateName: '해당 이름의 템플릿이 이미 존재합니다.',
    },

    jobAdApplication: {
      name: '이름',
      city: '거주지',
      email: '이메일',
      phone: '전화번호',
      applyForPosition: '직책 지원',
      back: '뒤로',
      continue: '계속',
      submit: '제출',
      saveForLater: '나중에 계속하기',
      namePlaceholder: '이름 입력',
      emailPlaceholder: '이메일 주소 입력',
      phonePlaceholder: '전화번호 입력',
      cityPlaceholder: '현재 거주지 입력',
      links: '링크 추가(예: LinkedIn 프로필)',
      legendBasicInfo: '기본 정보',
      legendLinks: '링크',
      legendAttachments: '첨부 파일',
      legendAdditionalFields: '추가 정보',
      coverLetter: '자기소개서',
      attachments: '첨부 파일',
      introduction: '여기에 자기소개를 간략히 작성하세요',
      thankYou: '감사합니다.',
      luck: '행운을 빕니다!',
      close: '닫기',
      required: '* 별표로 표시된 항목은 필수 항목입니다.',
    },

    jobAdContainer: {
      endTime: date => (date ? `${date}까지 사용 가능` : ''),
    },

    jobAdDetails: {
      apply: '입사 지원하기',
    },

    jobAdQuickInterview: {
      back: '뒤로',
      submit: '제출',
      saveForLater: '나중에 계속하기',
      title: '빠른 동영상 면접',
      description: '지원자를 더욱 빠르게 파악할 수 있는 속성 인터뷰 질문에 간단히 답변해 주시기 바랍니다. 본인만의 개성을 살리고 지원서에 생기를 불어넣으세요.',
      requiredNote: '이 과정은 입사 지원 절차의 일부이며, 답변을 녹화한 후에만 채용 담당자에게 지원서가 전달됩니다.',
      reminderNote: '바로 답변을 녹화하거나 나중에 이메일로 알림을 받은 후 계속 진행할 수 있습니다.',
    },

    jobAdRow: {
      responses: '지원',
      status: {
        open: '진행 중',
        filled: '작성됨',
        cancelled: '취소됨',
        done: '완료',
        close: '닫기',
        draft: '닫힘(초안)',
        hidden: '숨겨짐',
      },
    },

    interviewRow: {
      responses: '후보자',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'LinkedIn 프로필 표시',
    },

    linkedInButton: {
      error: '프로필을 가져오는 동안 오류가 발생했습니다. 다시 시도해 주세요.',
      buttonText: 'LinkedIn으로 신청하기',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'LinkedIn 프로필을 사용하여 지원서를 미리 작성할 수 있습니다',
      linkedInOr: '또는',
      error: '프로필을 가져오는 동안 오류가 발생했습니다. 다시 시도해 주세요.',
    },

    linkListInput: {
      addField: '추가',
      removeField: '제거',
      invalidUrl: '유효하지 않은 URL입니다.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: '로딩 중...',
      saving: '저장 중...',
      sending: '전송 중...',
    },

    modalApplicationForm: {
      applyForPosition: '직책 지원',
      continue: '계속',
      name: '이름 입력',
      email: '이메일 주소 입력',
      phoneNumber: '전화번호 입력',
      links: '링크를 입력할 수 있습니다',
      legendLinks: '링크',
      legendAttachments: '첨부 파일',
      coverLetter: '자기소개서',
      attachments: '첨부 파일',
      introduction: '여기에 자기소개를 작성하세요',
      thankYou: '감사합니다.',
      luck: '행운을 빕니다!',
      close: '닫기',
    },

    modalConfirm: {
      cancel,
      confirm: '확인',
    },

    modalAlert: {
      close: '닫기',
    },

    modalLinkShare: {
      title: '공유 가능한 공개 링크',
      info: '다음은 공유할 수 있는 채용 공고의 공개 주소입니다.\n해당 직책에 관심 있는 사람은 누구나 채용 공고를 보고 지원할 수 있습니다.\n지원서가 도착하기 시작하면 일반적인 알림을 받게 됩니다.\n채용 공고의 공개 링크는 다음과 같습니다.',
    },

    modalVideoAdd: {
      chooseTitle: '새 동영상 추가',
      title: '새 동영상 녹화',
      titlePlaceholder: '여기에 동영상 제목 입력',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: '새 동영상 업로드',
      info: '허용되는 최대 동영상 크기는 500MB입니다. 업로드하기 전에 동영상을 압축하는 것이 좋습니다. 이렇게 하면 업로드 및 변환에 소요되는 시간이 줄어듭니다.',
    },

    modalCandidateInfo: [
      {
        headline: '동영상 응답을 녹화하세요. ',
        content: '횟수에는 제한이 없습니다. 동영상은 녹화 후 즉시 저장되며, 이메일로 받은 링크를 통해 동영상 면접으로 돌아갈 수 있습니다.',
        mobileContent:'횟수에는 제한이 없습니다. 면접에 동영상을 추가하세요. 동영상이 업로드되어 면접에 저장되는 모습을 보실 수 있습니다. 이메일로 받은 링크를 통해 동영상 면접으로 돌아갈 수 있습니다. <br><br><strong>Apple 모바일 디바이스를 사용 중인데 동영상 화면이 계속 검은색으로 표시되는 경우에는 <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">여기</a>에서 문제 해결 방법에 관한 지침을 확인하세요.</strong>',
      },
      {
        headline: '녹화 후에는 ',
        content: '동영상이 올바르게 재생되고 음성이 들리는지 확인하세요. “제출” 버튼을 누르면 답변이 잠기면서 더 이상 수정할 수 없습니다.',
      },
      {
        headline: '면접이 종료되면 ',
        content: '“답변 전송 및 면접 완료” 버튼을 누르세요. 이후에는 동영상 면접으로 돌아갈 수 없습니다. 이 페이지를 닫고 나중에 면접을 계속하고 싶으시면 “나중에 계속하기” 버튼을 누르세요.',
      },
      {
        headline: '동영상 면접에 답변할 때 ',
        content: mailto => `도움이 필요한 경우에는 페이지 오른쪽 하단의 “도움말” 버튼을 클릭하거나 ${mailto} 주소로 이메일을 보내주세요.`,
        customContent: link => `${link}에 문의`,
      },
    ],

    navigationBar: {
      back: '뒤로',
      dashboard: '대시보드',
      frontpage: '앞면',
    },

    personDetails: {
      stage: '단계',
      namePlaceholder: '후보자',
      contact: '연락처',
      links: '링크',
      attachments: '첨부 파일',
      coverLetter: '자기소개서',
      referrer: '출처',
      referrerInfo: '후보자가 서비스를 방문할 때 사용한 웹사이트입니다.',
      noStage: '아직 아무 단계에도 해당하지 않습니다',
      lastSeen: time => `최근 조회: ${time}.`,
      headerAdditionalInformation: '추가 정보',
      state: {
        invited: '초대됨',
        visited: '방문함',
        incomplete: '미완료',
        completed: '완료됨',
      },
      notVisited: '아직 면접에 방문하지 않았습니다.',
      scheduledInterview: '미팅 정보',
      scheduledInterviewInvitationSent: '미팅에 초대됨',
      scheduledInterviewInvitationExpired: '초대가 만료되었습니다',
      scheduledInterviewInvitationEventCreated: '',
      scheduledInterviewReScheduleMeeting: '미팅 일정 변경',
      otherPersons: count => `${count}개의 다른 직책에서도 검색됨`,
    },

    phoneInput: {
      placeholder: example => `${example} 형식의 전화번호`,
    },

    questionsAndResponses: {
      response: '응답',
      noResponse: '응답 없음',
      // These are for admin side only so only admin side translations needed
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2:
        'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: '내 평가',
      yourVotePlaceholder: '아직 투표하지 않았습니다.',
      totalVotes: count => `총 ${count}회의 평가`,
      noRatings: '아직 평가 없음',
      mobileModalHeader: '내 평가 추가',
      yourRatingReset: '투표 초기화',
      averageRating: '평균 평가',
      reset: '초기화',
    },

    share: {
      share: '다음 대상에 공유:',
      copy: '링크 복사',
    },

    sort: {
      sort: '정렬',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: '선택됨',
      change: '변경',
    },

    video: {
      videoNotFound: '동영상이 처리 중이거나 동영상을 찾을 수 없습니다',
      retry: '다시 시도하세요',
      originalLanguageLabel: '원본',
      englishLanguageLabel: '영어',
    },

    videoUpload: {
      uploadPlaceholder: isMobile =>
        isMobile ? '새 동영상 업로드 또는 녹화' : '파일 선택',
      videoPlaceholder: '응답 녹화',
      uploadPlaceholderCandidate: 'Upload your response',
      submit: '응답 제출',
      notAnswered: '아직 답변하지 않으셨습니다',
      remove: '재촬영 영상 제거',
      converting: '동영상이 변환 중입니다. 잠시만 기다려주세요...',
      uploading: '동영상이 업로드 중입니다. 잠시만 기다려주세요...',
      error: {
        invalid: '선택한 파일이 너무 큽니다. 다른 파일을 선택해 주세요.',
        upload: '죄송하지만 동영상을 업로드할 수 없습니다. 다시 시도해 주세요.',
        transcode: '선택한 동영상 파일이 손상되었거나 유효하지 않습니다. 다시 시도하세요.',
      },
    },

    virtualBg: {
      showMoreButtonText: '더 보기',
      showLessButtonText: '간단히 보기',
      infoText1:
        '녹화하는 동안 탭을 포그라운드에 활성 상태로 유지하세요. 녹화 중에는 다른 애플리케이션을 사용해서는 안 됩니다.',
      infoText2:
        '동영상 배경 동영상은 최신 브라우저와 비교적 새롭고 강력한 기기에서 가장 잘 작동합니다.',
      infoText3:
        '다른 애플리케이션이 마이크나 카메라를 사용하고 있지 않은지 확인하세요.',
    },

    videoResponse: {
      videoPlaceholder: '응답 녹화',
      submit: '응답 제출',
      uploadPlaceholder: 'Upload your response',
      startInterview: '면접 시작하기',
      notAnswered: '아직 답변하지 않으셨습니다',
      required: '이 질문에는 답변이 필요합니다',
    },

    webcam: {
      useVideoBgButtonText: '동영상 배경 사용',
      removeVideoBgButtonText: '동영상 배경 제거',
      starting: '시작 중...',
      close: '카메라 닫기',
      remove: '재촬영 영상 제거',
      record: '녹화',
      stop: '중지',
      retake: '재촬영',
      submit: '응답 제출',
      converting: '동영상이 변환 중입니다. 잠시만 기다려주세요...',
      uploading: '동영상이 업로드 중입니다. 잠시만 기다려주세요...',
      downloading: '동영상이 다운로드 중입니다. 잠시만 기다려주세요...',
      processing: '처리 중...',
      uploadInProgress: '동영상 전송이 아직 진행 중입니다. 브라우저를 닫거나 페이지를 변경하지 마세요.',
      uploaded: '동영상 전송됨.',
      error: {
        DevicesNotFoundError: '카메라 또는 마이크를 사용할 수 없습니다. 활성화되어 있는지 확인하세요.',
        NotFoundError: '카메라 또는 마이크를 사용할 수 없습니다. 활성화되어 있는지 확인하세요.',
        NotAllowedError: '카메라나 마이크 사용 권한을 부여하지 않았습니다.',
        PermissionDismissedError: '권한 대화 상자를 닫으셨습니다. 카메라 및 마이크 사용 권한을 부여하세요.',
        PermissionDeniedError: '카메라 또는 마이크 액세스가 거부되었습니다.',
        NotReadableError: '카메라 또는 마이크 스트림을 읽을 수 없습니다. 하드웨어 문제일 수 있습니다.',
        SecurityError: '보안 오류로 인해 카메라 또는 마이크를 사용할 수 없습니다',
        stream: '오류가 발생했습니다. 브라우저를 다시 시작하세요. 문제가 지속되면 다른 브라우저로 시도하세요.',
        download: '동영상을 다운로드하지 못했습니다. 다시 시도하시겠어요?',
        upload: '동영상을 업로드하지 못했습니다. 다시 시도하시겠어요?',
        emptyBlob: '브라우저 또는 디바이스 메모리가 꽉 차서 녹화 파일을 만들 수 없습니다. 페이지를 새로 고친 다음에도 문제가 해결되지 않으면 브라우저를 다시 시작하세요.  문제가 지속되면 다른 브라우저로 시도하세요.',
        alternativeRecorder: '여기를 클릭해도 파일 업로드를 사용할 수 있습니다.',
        reconnecting: '연결이 중단되었습니다. 다시 연결을 시도합니다.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `안녕하세요! 동영상 인터뷰 ${title}에 여러분을 초대합니다! 이 초대는 이메일로도 전송되었습니다. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
